import { useMemo } from "react";
import { useSiteContent } from "@/lib/siteContent";

/**
 * Erleben-Landing (`/erleben`) — Master-Switch-Hook.
 *
 * Sichtbarkeits-Regel:
 *  - `erleben.enabled === true` im CMS (Master-Switch aus dem Admin unter
 *    `/admin/qr-kampagne`, Sektion "Sichtbarkeit").
 *
 * Speicher-Struktur analog zu `aktion` (siehe `useAktion.ts`):
 *  - CMS-Key: `erleben`
 *  - Value:   `{ enabled: boolean }`
 *
 * `ready` gibt an, ob der initiale Fetch abgeschlossen ist — für den
 * Route-Guard wichtig, um während des Ladens **keinen** vorzeitigen
 * Redirect auszulösen (kein Flackern beim Reload).
 *
 * Default-Verhalten: enabled=true (Bestandsdaten ohne diesen Key sollen
 * sichtbar bleiben, Backwards-Compat).
 */
export type ErlebenContent = {
    enabled: boolean;
};

const DEFAULTS: ErlebenContent = {
    enabled: true,
};

export function useErleben(): ErlebenContent & { ready: boolean } {
    const site = useSiteContent();
    const cms = site.getObject<Partial<ErlebenContent>>("erleben", {});
    const merged: ErlebenContent = useMemo(() => ({
        ...DEFAULTS,
        // Force boolean coercion — CMS könnte string liefern.
        enabled: cms?.enabled !== undefined ? cms.enabled === true : DEFAULTS.enabled,
    }), [cms]);
    return { ...merged, ready: site.ready };
}
